// src/core/services/store/notification.module.js

import ApiService from "@/core/services/api.service";

// Action Types
export const FETCH_NOTIFICATIONS = "fetchNotifications";
export const FETCH_NOTIFICATION = "fetchNotification";
export const MARK_ALL_AS_SEEN = "markAllAsSeen";

// Mutation Types
export const SET_NOTIFICATIONS = "setNotifications";
export const SET_NOTIFICATIONS_PAGINATION = "setNotificationsPagination";
export const SET_NOTIFICATION = "setNotification";

const state = {
  notifications: [],
  notification: {},
  unreadNotificationCount: 0,
  notificationsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 15,
  },
};

const getters = {
  notifications(state) {
    return state.notifications;
  },
  notification(state) {
    return state.notification;
  },
  unreadNotificationCount(state) {
    return state.notifications.filter((n) => !n.seen_at).length;
  },
  notificationsPagination(state) {
    return state.notificationsPagination;
  },
};

const actions = {
  [FETCH_NOTIFICATIONS](context, payload = {}) {
    let params = {
      page: context.state.notificationsPagination.currentPage,
    };

    // اگر payload داشت (مثلاً فیلتر در آینده)
    if (payload.page) {
      params.page = payload.page;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("notifications", { params })
        .then(({ data }) => {
          context.commit(SET_NOTIFICATIONS, data.data || data);
          context.commit(SET_NOTIFICATIONS_PAGINATION, {
            total: data.total || data.length,
            currentPage: data.current_page || 1,
            firstPage: data.first_page || 1,
            lastPage: data.last_page || 1,
            perPage: data.per_page || 15,
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [FETCH_NOTIFICATION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(`notifications/${id}`)
        .then(({ data }) => {
          const notif = data.data || data;
          context.commit(SET_NOTIFICATION, notif);

          if (!notif.seen_at) {
            const index = context.state.notifications.findIndex(
              (n) => n.id === notif.id
            );
            if (index !== -1) {
              context.state.notifications[index].seen_at =
                new Date().toISOString();
            }
          }

          resolve(notif);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [MARK_ALL_AS_SEEN]({ commit, state }) {
    return new Promise((resolve, reject) => {
      ApiService.post("notifications/mark-all-as-seen")
        .then(() => {
          const updatedNotifications = state.notifications.map((notif) => ({
            ...notif,
            seen_at: new Date().toISOString(),
          }));

          commit(SET_NOTIFICATIONS, updatedNotifications);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const mutations = {
  [SET_NOTIFICATIONS](state, notifications) {
    state.notifications = Array.isArray(notifications) ? notifications : [];
    state.unreadNotificationCount = state.notifications.filter(
      (n) => !n.seen_at
    ).length;
  },

  [SET_NOTIFICATIONS_PAGINATION](state, data) {
    state.notificationsPagination = {
      total: data.total,
      currentPage: data.currentPage,
      firstPage: data.firstPage,
      lastPage: data.lastPage,
      perPage: data.perPage,
    };
  },

  [SET_NOTIFICATION](state, notification) {
    state.notification = notification;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
